import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { StoreProvider } from "./context/StoreContext";
import { getImageUrl } from "./services/api";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LoadingBackend from "./components/LoadingBackend";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Success from "./pages/Success";
import About from "./pages/About";
import Extra from "./pages/Extra";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import "./App.css";

function App() {
  const [backendReady, setBackendReady] = useState(false);
  const [checkingBackend, setCheckingBackend] = useState(true);

  // Précharger les images critiques dès le chargement de l'app
  useEffect(() => {
    const preloadImages = () => {
      const imagesToPreload = [
        getImageUrl("hero-home"),
        getImageUrl("logo"),
      ];

      imagesToPreload.forEach((url) => {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = url;
        document.head.appendChild(link);
      });
    };

    preloadImages();
  }, []);

  // Vérifier la disponibilité initiale du backend
  useEffect(() => {
    const checkBackend = async () => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);

        const response = await fetch(
          `${
            process.env.REACT_APP_API_URL || "http://localhost:5000/api"
          }/products`,
          {
            signal: controller.signal,
            method: "HEAD",
          }
        );

        clearTimeout(timeoutId);

        if (response.ok) {
          setBackendReady(true);
        }
      } catch (error) {
        // Backend not available — loading screen remains visible
      } finally {
        setCheckingBackend(false);
      }
    };

    checkBackend();
  }, []);

  const handleBackendReady = () => {
    setBackendReady(true);
  };

  if (checkingBackend) {
    return null; // Ou un petit loader simple
  }

  if (!backendReady) {
    return <LoadingBackend onBackendReady={handleBackendReady} />;
  }

  return (
    <StoreProvider>
      <CartProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <ScrollToTop />
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/success" element={<Success />} />
                <Route path="/about" element={<About />} />
                <Route path="/extra" element={<Extra />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </StoreProvider>
  );
}

export default App;
